import Complete from './complete';
import { requestManager } from '../../requestManager';
import { API_PATH } from '../../config/config';

class CustomReserveComplete extends Complete.Constructor {
  /**
   * カスタマイズで登録した受付データの取得
   * @param {Number} receptionId 受付ID
   * @returns {Promise<Object>} 受付データ
   */
  getCustomReception = async (receptionId) => {
    const result = await requestManager.post(`${API_PATH}/customformcomplete/r/`, {
      receptionId,
    });
    return result.data;
  };
}

export default new CustomReserveComplete();
